import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { createSuburbanOffersHistoryListingMapper, TMappedResponse } from './mappers';
import { IThunkContext } from '../../../types/redux';
import {
  fetchPublicSuburbanV1GetOffersHistory,
  IPublicSuburbanV1GetOffersHistoryRequest,
} from '../../../repositories/valuation-offer-history/suburban/v1/get-offers-history';

export const fetchOffersHistorySuburbanListing = async (
  context: IThunkContext,
  parameters: IPublicSuburbanV1GetOffersHistoryRequest,
) => {
  try {
    const res = (await fetchPublicSuburbanV1GetOffersHistory({
      httpApi: context.httpApi,
      parameters,
      mappers: createSuburbanOffersHistoryListingMapper(parameters),
    })) as TMappedResponse;

    if (res instanceof Error) {
      throw res;
    }

    return res;
  } catch (error) {
    if (error instanceof HttpBadStatusCodeError) {
      context.logger.debug('suburban/v1/get-offers-history BadRequest', { details: error.printDetails() });
    } else {
      context.logger.error(error, { message: 'Error in suburban/v1/get-offers-history', ...parameters });
    }

    throw error;
  }
};
